import React, { useEffect, useReducer, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import OtpInput from "react-otp-input";
import { Formik } from "formik";
import loginValidationSchema from "./LoginValidation";
import { emailValidationScehema } from "./LoginValidation";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import Loader from "../../UI Component/Loader/Loader";
import authAxios from "../../../Util/API Calls/authAxios";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
const initialState = {
  showOtpTimer: false,
  loading: false,
};

const LoginModal = ({
  show,
  hideModal,
  selectedSlot,
  startTime,
  appointmentDate,
  doctorDetails,
  loginSuccessHandler,
  emailVerify,
}) => {
  const history = useHistory();
  const [state, dispatch] = useReducer(reducer, initialState);
  let myInterval = useRef(0);
  const [otpTimer, setOtpTimer] = useState({ minutes: 2, seconds: 0 });
  const { showOtpTimer, loading } = state;
  const [userName, setUserNumber] = useState("");

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    setOtpTimer({ minutes: 2, seconds: 0 });
  }, [myInterval.current]);

  useEffect(() => {
    if (!show) {
      clearInterval(myInterval.current);
      setOtpTimer({ minutes: 2, seconds: 0 });
      dispatch({ type: "setShowOtpTimer", payload: { showOtpTimer: false } });
      myInterval.current = 0;
    }
  }, [show]);

  const isNumber = (character = "") => {
    return character.match(/^[0-9]*$/);
  };

  const startTimer = () => {
    clearInterval(myInterval.current);
    dispatch({ type: "setShowOtpTimer", payload: { showOtpTimer: true } });
    let minutes = 2;
    let seconds = 0;
    myInterval.current = setInterval(() => {
      if (seconds > 0) {
        seconds = seconds - 1;
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval.current);
          dispatch({
            type: "setShowOtpTimer",
            payload: { showOtpTimer: false },
          });
          myInterval.current = 0;
        } else {
          minutes = minutes - 1;
          seconds = 59;
        }
      }
      setOtpTimer({ minutes, seconds });
    }, 1000);
  };

  const loginSubmit = async (values, { resetForm }) => {
    dispatch({ type: "setLoading", payload: { loading: true } });
    if (emailVerify) {
      try {
        const response = await afterLoginApiAxios.post(
          "/patient/update-login-email",
          {
            patient_id: userId,
            login_email: values.email,
            email_verification_code: values.otp,
          },
          {
            headers: {
              Authorization: localStorage.getItem("id_token"),
            },
          }
        );
        dispatch({ type: "setLoading", payload: { loading: false } });
        if (response.data.statusCode === 200) {
          swal({
            icon: "success",
            title: response.data.message,
          }).then(() => history.push("/appointments/book"));
        } else {
          swal({
            title: "Login Failed!",
            text: response.data.message,
            icon: "warning",
          }).then(function () {
            // hideModal();
            // resetForm();
          });
        }
      } catch (error) {
        dispatch({ type: "setLoading", payload: { loading: false } });

        C2CConsole.log(error);
        if (error)
          swal({
            title: "Login Failed!",
            text: "Something Went Wrong!!Try Again",
            icon: "warning",
          }).then(() => {
            resetForm();
          });
      }
    } else {
      try {
        const response = await authAxios.post("login", {
          phone_no: "+91" + values.phoneNumber,
          user_otp: values.otp,
          user_type: "patient",
        });
        dispatch({ type: "setLoading", payload: { loading: false } });
        if (response.data.statusCode === 200) {
          setUserNumber(response.data.user.user_name);
          localStorage.removeItem("ecaregiverName");
          localStorage.removeItem("ecaregiverEmail");
          localStorage.removeItem("ecaregiverageProof");
          localStorage.removeItem("ecaregivergovtID");
          localStorage.removeItem("epatientPhone");
          localStorage.setItem("id_token", response.data.user.id_token);
          localStorage.setItem("user_name", response.data.user.user_name);
          localStorage.setItem("user_type", response.data.user.user_type);
          localStorage.setItem(
            LOCALSTORAGEKEY.USER_ID,
            response.data.user.user_id
          );
          localStorage.setItem("slot_id", selectedSlot);
          localStorage.setItem("start", startTime);
          localStorage.setItem("login_email", response.data.user.login_email);
          localStorage.setItem(
            "date",
            moment(appointmentDate.meta).format("YYYY-MM-DD")
          );
          localStorage.setItem("doctor", JSON.stringify(doctorDetails));

          swal({
            title: localStorage.getItem("login_email")
              ? "Login Successfully"
              : "Phone number verified Successfully",
            // text: response.data.message,
            icon: "success",
          }).then(() => {
            resetForm();
            clearInterval(myInterval.current);
            setOtpTimer({ minutes: 2, seconds: 0 });
            dispatch({
              type: "setShowOtpTimer",
              payload: { showOtpTimer: false },
            });
            myInterval.current = 0;
            loginSuccessHandler();
          });
        } else {
          swal({
            title: "Login Failed!",
            text: response.data.message,
            icon: "warning",
          }).then(function () {
            // hideModal();
            // resetForm();
          });
        }
      } catch (error) {
        dispatch({ type: "setLoading", payload: { loading: false } });

        C2CConsole.log(error);
        if (error)
          swal({
            title: "Login Failed!",
            text: "Something Went Wrong!!Try Again",
            icon: "warning",
          }).then(() => {
            resetForm();
          });
      }
    }
  };

  const sendOtpOnEmail = async (
    values,
    { errors, setTouched, setErrors, touched }
  ) => {
    if (errors.email) {
      return setTouched({ ...touched, email: true });
    }
    // Validation Successful
    dispatch({ type: "setLoading", payload: { loading: true } });
    try {
      const response = await afterLoginApiAxios.post(
        "patient/get-verification-code",
        {
          login_email: values.email,
          patient_id: userId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("id_token"),
          },
        }
      );
      if (response.data.statusCode === 200) {
        startTimer();
        swal({
          icon: "success",
          title: "OTP Sent Successfully",
        });
      } else {
        // Request Unsuccessful
        swal({
          icon: "error",
          title: "Cannot Send OTP",
          text: response.data.message,
        });
      }
    } catch (e) {
      swal({
        icon: "error",
        title: "Cannot Send OTP",
        text: e?.response?.message,
      });
    }
    dispatch({ type: "setLoading", payload: { loading: false } });
  };

  const sendOtp = async (
    values,
    { errors, setTouched, setErrors, touched }
  ) => {
    if (errors.phoneNumber) {
      return setTouched({ ...touched, phoneNumber: true });
    }
    if (!values.phoneNumber) {
      setTouched({ ...touched, phoneNumber: true });
      return setErrors({ ...errors, phoneNumber: "Phone Number is invalid" });
    }
    // Validation Successful
    dispatch({ type: "setLoading", payload: { loading: true } });
    try {
      const response = await afterLoginApiAxios.post("public/send-otp", {
        phone_no: "+91" + values.phoneNumber,
        channel_id: "patient-login",
      });
      if (response.data.statusCode === 200) {
        startTimer();
        swal({
          icon: "success",
          title: response.data.message,
          className: "titleStyle",
        });
      } else {
        // Request Unsuccessful
        swal({
          icon: "error",
          title: "Cannot Send OTP",
          text: response.data.message,
        });
      }
    } catch (e) {
      swal({
        icon: "error",
        title: "Cannot Send OTP",
        text: e?.response?.message,
      });
    }
    dispatch({ type: "setLoading", payload: { loading: false } });
  };
  return (
    <Modal show={show} onHide={hideModal}>
      {loading && <Loader />}
      <div className="row d-flex justify-content-center">
        <Formik
          initialValues={{
            phoneNumber: "",
            otp: "",
            email: "",
          }}
          onSubmit={loginSubmit}
          validationSchema={
            emailVerify ? emailValidationScehema : loginValidationSchema
          }
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setTouched,
            setErrors,
            setFieldValue,
            isSubmitting,
          }) => (
            <>
              {/* <form onSubmit={handleSubmit}>
              <div className="col-sm-12 text-center pt-3">
                <label className="otp-label">+91</label>
                <input
                  style={{ marginLeft: "0px", width: "auto" }}
                  type="number"
                  name="phoneNumber"
                  value={values["phoneNumber"]}
                  onBlur={handleBlur}
                  placeholder="Enter Phone Number"
                  className="input-col phoneInputOtp"
                  onChange={handleChange}
                />
                <div style={{ color: "#F969A4" }}>
                  {errors.phoneNumber && touched.phoneNumber
                    ? errors.phoneNumber
                    : ""}
                </div>
                <button
                  disabled={myInterval.current}
                  className="otp-btn mt-4"
                  type="button"
                  onClick={() =>
                    sendOtp(values, { errors, touched, setTouched, setErrors })
                  }
                >
                  {myInterval.current ? "Resend OTP" : "Send"}
                </button>
                {showOtpTimer &&
                !(otpTimer.minutes === 0 && otpTimer.seconds === 0)
                  ? `${otpTimer.minutes}:${
                      otpTimer.seconds < 10
                        ? `0${otpTimer.seconds}`
                        : otpTimer.seconds
                    } left to expire`
                  : null}
              </div>
              <div className="col-sm-12 text-left otpFields mt-4 flex-column">
                <div>
                  <OtpInput
                    onChange={(value) => {
                      setFieldValue("otp", value);
                      setTouched({ ...touched, otp: true });
                    }}
                    numInputs={6}
                    value={values["otp"]}
                  />
                </div>
                <span style={{ color: "#F969A4", textAlign: "center" }}>
                  {errors.otp && touched.otp ? errors.otp : ""}
                </span>
              </div>
              <button
                disabled={isSubmitting}
                className="otp-btn"
                type={"submit"}
              >
                Verify
              </button>
            </form> */}
              {emailVerify ? (
                <form onSubmit={handleSubmit}>
                  <div className="text-center mr-4">
                    <label style={{ color: "#F969A4" }}>Phone : </label>{" "}
                    <span> {userName}</span>
                  </div>
                  <div className="col-sm-12 text-center">
                    <small style={{ color: "#F969A4" }}>
                      Email verification helps you to receive OTP on email
                    </small>
                    <input
                      style={{ marginLeft: "0px", width: "auto" }}
                      type="email"
                      name="email"
                      value={values["email"]}
                      onBlur={handleBlur}
                      placeholder="Enter Email Address"
                      className="input-col phoneInputOtp"
                      onChange={handleChange}
                    />
                    <div style={{ color: "#F969A4" }}>
                      {errors.email && touched.email ? errors.email : ""}
                    </div>
                    <button
                      disabled={myInterval.current}
                      style={{ width: "150px" }}
                      className="otp-btn mt-4"
                      type="button"
                      onClick={() =>
                        sendOtpOnEmail(values, {
                          errors,
                          touched,
                          setTouched,
                          setErrors,
                        })
                      }
                    >
                      {myInterval.current ? "Resend OTP" : "Send Email OTP"}
                    </button>
                    {showOtpTimer &&
                    !(otpTimer.minutes === 0 && otpTimer.seconds === 0)
                      ? `${otpTimer.minutes}:${
                          otpTimer.seconds < 10
                            ? `0${otpTimer.seconds}`
                            : otpTimer.seconds
                        } left to expire`
                      : null}
                  </div>
                  <div className="col-sm-12 text-left otpFields mt-4 flex-column">
                    <div>
                      <OtpInput
                        onChange={(value) => {
                          setFieldValue("otp", value);
                          setTouched({ ...touched, otp: true });
                        }}
                        numInputs={6}
                        value={values["otp"]}
                      />
                    </div>
                    <span style={{ color: "#F969A4", textAlign: "center" }}>
                      {errors.otp && touched.otp ? errors.otp : ""}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className="mb-3"
                  >
                    <button
                      style={{ margin: "0 0 0 63px", display: "initial" }}
                      disabled={isSubmitting}
                      className="otp-btn"
                      type={"submit"}
                    >
                      Verify
                    </button>
                    <Link className="do_it_btn" to="/appointments/book">
                      Skip for now{" "}
                      <span>
                        <i className="fa fa-angle-right"></i>
                      </span>
                    </Link>
                  </div>
                </form>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="col-sm-12 text-center pt-3">
                    <label className="otp-label">+91</label>
                    <input
                      style={{ marginLeft: "0px", width: "auto" }}
                      name="phoneNumber"
                      value={values["phoneNumber"]}
                      onBlur={handleBlur}
                      placeholder="Enter Phone Number"
                      className="input-col phoneInputOtp"
                      onChange={(event) => {
                        if (
                          isNumber(
                            event.target.value[event.target.value.length - 1]
                          )
                        )
                          setFieldValue("phoneNumber", event.target.value);
                      }}
                    />
                    <div style={{ color: "#F969A4" }}>
                      {errors.phoneNumber && touched.phoneNumber
                        ? errors.phoneNumber
                        : ""}
                    </div>
                    <button
                      disabled={myInterval.current}
                      className="otp-btn mt-4"
                      type="button"
                      onClick={() =>
                        sendOtp(values, {
                          errors,
                          touched,
                          setTouched,
                          setErrors,
                        })
                      }
                    >
                      {myInterval.current ? "Resend OTP" : "Send"}
                    </button>
                    {showOtpTimer &&
                    !(otpTimer.minutes === 0 && otpTimer.seconds === 0)
                      ? `${otpTimer.minutes}:${
                          otpTimer.seconds < 10
                            ? `0${otpTimer.seconds}`
                            : otpTimer.seconds
                        } left to expire`
                      : null}
                  </div>
                  <div className="col-sm-12 text-left otpFields mt-4 flex-column">
                    <div>
                      <OtpInput
                        onChange={(value) => {
                          setFieldValue("otp", value);
                          setTouched({ ...touched, otp: true });
                        }}
                        numInputs={6}
                        value={values["otp"]}
                      />
                    </div>
                    <span style={{ color: "#F969A4", textAlign: "center" }}>
                      {errors.otp && touched.otp ? errors.otp : ""}
                    </span>
                  </div>
                  <button
                    disabled={isSubmitting}
                    className="otp-btn mb-3"
                    type={"submit"}
                  >
                    Verify
                  </button>
                </form>
              )}
            </>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setShowOtpTimer":
      return {
        ...state,
        showOtpTimer: action.payload.showOtpTimer,
      };
    case "setLoading":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return { ...state };
  }
};

export default LoginModal;
